// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PublicSchemaTypes from '../../graphql/public/PublicSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type UserByTokenQueryVariables = PublicSchemaTypes.Exact<{
  token: PublicSchemaTypes.Scalars['String'];
}>;


export type UserByTokenQuery = (
  { __typename?: 'Query' }
  & { user?: PublicSchemaTypes.Maybe<(
    { __typename?: 'UserModelPublicBase' }
    & Pick<PublicSchemaTypes.UserModelPublicBase, 'id' | 'email' | 'userIdentity' | 'hasOwnPasswordSet'>
  )> }
);

export type VerifyUserTokenMutationVariables = PublicSchemaTypes.Exact<{
  token: PublicSchemaTypes.Scalars['String'];
}>;


export type VerifyUserTokenMutation = (
  { __typename?: 'Mutation' }
  & { verifyUser?: PublicSchemaTypes.Maybe<(
    { __typename?: 'UserModelPublicBase' }
    & Pick<PublicSchemaTypes.UserModelPublicBase, 'id' | 'email' | 'verified'>
  )> }
);

export type ResetPasswordMutationVariables = PublicSchemaTypes.Exact<{
  userId: PublicSchemaTypes.Scalars['PositiveInt'];
  password: PublicSchemaTypes.Scalars['String'];
  token: PublicSchemaTypes.Scalars['String'];
}>;


export type ResetPasswordMutation = (
  { __typename?: 'Mutation' }
  & { resetPassword?: PublicSchemaTypes.Maybe<(
    { __typename?: 'UserModelBase' }
    & Pick<PublicSchemaTypes.UserModelBase, 'id' | 'userIdentity' | 'verified'>
  )> }
);


export const UserByTokenDocument = gql`
    query UserByToken($token: String!) {
  user(token: $token) {
    id
    email
    userIdentity
    hasOwnPasswordSet
  }
}
    `;

/**
 * __useUserByTokenQuery__
 *
 * To run a query within a React component, call `useUserByTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserByTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserByTokenQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useUserByTokenQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UserByTokenQuery, UserByTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserByTokenQuery, UserByTokenQueryVariables>(UserByTokenDocument, options);
      }
export function useUserByTokenLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserByTokenQuery, UserByTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserByTokenQuery, UserByTokenQueryVariables>(UserByTokenDocument, options);
        }
export type UserByTokenQueryHookResult = ReturnType<typeof useUserByTokenQuery>;
export type UserByTokenLazyQueryHookResult = ReturnType<typeof useUserByTokenLazyQuery>;
export type UserByTokenQueryResult = Apollo.QueryResult<UserByTokenQuery, UserByTokenQueryVariables>;
export const VerifyUserTokenDocument = gql`
    mutation verifyUserToken($token: String!) {
  verifyUser(token: $token) {
    id
    email
    verified
  }
}
    `;
export type VerifyUserTokenMutationFn = Apollo.MutationFunction<VerifyUserTokenMutation, VerifyUserTokenMutationVariables>;

/**
 * __useVerifyUserTokenMutation__
 *
 * To run a mutation, you first call `useVerifyUserTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyUserTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyUserTokenMutation, { data, loading, error }] = useVerifyUserTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useVerifyUserTokenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<VerifyUserTokenMutation, VerifyUserTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<VerifyUserTokenMutation, VerifyUserTokenMutationVariables>(VerifyUserTokenDocument, options);
      }
export type VerifyUserTokenMutationHookResult = ReturnType<typeof useVerifyUserTokenMutation>;
export type VerifyUserTokenMutationResult = Apollo.MutationResult<VerifyUserTokenMutation>;
export type VerifyUserTokenMutationOptions = Apollo.BaseMutationOptions<VerifyUserTokenMutation, VerifyUserTokenMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation resetPassword($userId: PositiveInt!, $password: String!, $token: String!) {
  resetPassword(userId: $userId, password: $password, token: $token) {
    id
    userIdentity
    verified
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      password: // value for 'password'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;